/* eslint-disable no-unused-vars */
import { useNavigate } from "react-router-dom";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import OtpInput from 'react-otp-input';
import './otp.css';
import bgImage from "assets/images/bg-sign-up-cover.jpeg";
import React, { useState } from "react";
import {
  Grid,
} from "@mui/material";
import swal from "sweetalert";
import LoginLayout from "layouts/loginLayout/loginLayout";
import { validateOTP } from "utils/authApi";
import { useDispatch } from "react-redux";
import { userResendOTP } from "utils/authApi";
import { showResMsg } from "utils/generic";

const errMsg = {
  color: `red`,
  fontSize: `11px`,
  margin: `8px 0px`
};

let SIGN_UP_DETAILS;
let mandateFlag = false;

function Otp({ ...props }) {
  const [emailOTPErr, setEmailOTPErr] = useState(false);
  const [mobileOTPErr, setMobileOTPErr] = useState(false);
  const [mobileNumberExist, setMobileNumberExist] = useState((JSON.parse(sessionStorage.getItem('SIGN_UP_DETAILS')))?.mobileNumberExist);
  const [emailOTP, setEmailOTP] = useState();
  const [mobileOTP, setMobileOTP] = useState();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleEmailOTP = val => {
    setEmailOTP(val);
    values.emailOTP = val;
  };

  const handleMobileOTP = val => {
    setMobileOTP(val);
    values.mobileOTP = val;

  };
  const [values, setValues] = React.useState({
    emailOTP: '',
    mobileOTP: '',
    mobileNumberExist: false,
    userId: '',
    userPassword: '',
    firstName: '',
    lastName: '',
  });
  let resendOTPApi
  let ValidateOTPApi
  let routePath;


  SIGN_UP_DETAILS = JSON.parse(sessionStorage.getItem('SIGN_UP_DETAILS'));
  if (SIGN_UP_DETAILS.customerType !== "" && SIGN_UP_DETAILS.customerType !== undefined && SIGN_UP_DETAILS.customerType !== null) {
    resendOTPApi = "customer/resendOTP"
    ValidateOTPApi = "customer/validateOTP"
    routePath = "/customerLogin"
  } else {
    resendOTPApi = "login/resendOTP"
    ValidateOTPApi = "login/validateOTP"
    routePath = "/login"
  }
  values.emailAddress = SIGN_UP_DETAILS.emailAddress;
  if (mobileNumberExist)
    values.phoneNumber = SIGN_UP_DETAILS.phoneNumber;

  async function handleSubmit() {
    try {
      values.mobileNumberExist = mobileNumberExist;
      values.userPassword = SIGN_UP_DETAILS.userPassword;
      mandateFlag = false;
      if (values.emailOTP.length !== 6 || !Number.isInteger(Number.parseInt(values.emailOTP))) {
        setEmailOTPErr(true);
        mandateFlag = true;
      } else setEmailOTPErr(false);
      if (mobileNumberExist) {
        if (values.mobileOTP.length !== 6 || !Number.isInteger(Number.parseInt(values.mobileOTP))) {
          setMobileOTPErr(true);
          mandateFlag = true;
        } else setMobileOTPErr(false);
      }
      if (mandateFlag) {
        return;
      }
      else {
        validateOTP(values, ValidateOTPApi, (data) => {
          if (data.Result_Status) {
            sessionStorage.clear();
            swal({
              title: "Welcome to Invoice & Recover! please login.", text: "", icon: "success", color: 'green',
              buttons: { confirm: { text: 'Login', className: 'btn-success centerButton', } }, closeOnClickOutside: false, closeOnEsc: false,
            })
              .then((value) => {
                if (value) {
                  navigate(routePath)
                }
              })
              .catch(error => {
                console.log("Error in swal");
              });
          }
          else {
            showResMsg(data.Result_Message, 1000, data.Result_Status);
          }
        }, dispatch)
      }
    } catch (error) {
      console.log("Catch in handleSubmit==", error);
    }
  };

  async function resendOTP(sendOtpTo) {
    try {
      values.emailAddress = SIGN_UP_DETAILS.emailAddress;
      values.phoneNumber = SIGN_UP_DETAILS.phoneNumber;
      values.firstName = SIGN_UP_DETAILS.firstName;
      values.lastName = SIGN_UP_DETAILS.lastName;
      values.sendOtpTo = sendOtpTo;
      userResendOTP(values, resendOTPApi, (data) => {
        showResMsg(data.Result_Status ? "OTP sent successfully on " + sendOtpTo : data.Result_Message, 1000, data.Result_Status);
      }, dispatch)
    } catch (error) {
      console.log("Catch in resendOTP==", error);
    }
  };

  return (
    <LoginLayout image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="success"
          mx={2}
          mt={-3}
          p={3}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Get Started With Your Silver Plan
          </MDTypography>


        </MDBox>

        <Grid container p={1.5}>
          <Grid item xs={12} lg={12} style={{ textAlign: "center" }}>
            <MDTypography display="block" variant="button" color="black" my={1}>
              Please enter OTP sent to {values.emailAddress}
            </MDTypography></Grid>
          <Grid item xs={12} lg={12} style={{ display: "flex", justifyContent: "center" }}>
            <OtpInput

              shouldAutoFocus={true}
              inputStyle="otp-input-style"
              numInputs={6}
              separator={<span></span>}
              value={emailOTP}
              onChange={handleEmailOTP}
              isInputNum
              inputType={'tel'}
              renderInput={(props) => <input  {...props} style={{ width: "2em" }} />} />
            <MDTypography pl={2}
              component="a"
              onClick={() => resendOTP("Email")}
              variant="button"
              fontWeight="bold"
              color="info"
              textGradient
              style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
            >
              Resend OTP&nbsp;&nbsp;
            </MDTypography>
          </Grid>

          <Grid item xs={12} lg={10} mt={0} style={{ display: "flex", justifyContent: "center" }}>
            {emailOTPErr ? <span style={errMsg}>Email OTP can't be blank</span> : ""}
          </Grid>
          <Grid item xs={12} lg={12} style={{ display: "flex", justifyContent: "center" }}>
          </Grid>
        </Grid>

        {mobileNumberExist && <>
          <Grid container p={1.5}>
            <Grid item xs={12} lg={12} style={{ textAlign: "center" }}>
              <MDTypography display="block" variant="button" color="black" my={1}>
                Please enter OTP sent to {values.phoneNumber}
              </MDTypography></Grid>
            <Grid item xs={12} lg={12} style={{ display: "flex", justifyContent: "center" }}>
              <MDBox>
                <OtpInput
                  // shouldAutoFocus={true}
                  inputStyle="otp-input-style"
                  numInputs={6}
                  separator={<span></span>}
                  inputProps={{
                    pattern: '^[0-9]+$',
                    maxLength: 6,
                  }}
                  value={mobileOTP} onChange={handleMobileOTP} type="text" isInputNum inputType={'tel'} renderInput={(props) => <input  {...props} style={{ width: "2em" }} />} />

              </MDBox>
              <MDTypography pl={2}
                component="a"
                onClick={() => resendOTP("Mobile")}
                variant="button"
                fontWeight="bold"
                color="info"
                textGradient
                style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
              >
                Resend OTP&nbsp;&nbsp;
              </MDTypography>
            </Grid>
            <Grid item xs={12} lg={10} style={{ display: "flex", justifyContent: "center" }}>
              {mobileOTPErr ? <span style={errMsg}>Mobile OTP can't be blank</span> : ""}
            </Grid>
          </Grid>
        </>}
        <Grid container px={1.5} pt={1.5} pb={3} style={{ display: "flex", justifyContent: "center" }}>
          <Grid item xs={4}>
            <MDBox  >
              <MDButton variant="gradient" color="info" fullWidth onClick={handleSubmit}>
                Verify
              </MDButton>
            </MDBox>
          </Grid>
        </Grid>

      </Card>
    </LoginLayout>
  );
}

export default Otp;
